export default "__VITE_ASSET__08bA4Hpz__"